import { DataProxy } from 'apollo-cache';
import produce from 'immer';

import { DeletePageMutation, Maybe, PagesQuery } from '../../generated/graphql';
import { pagesQuery } from '../LeftContainer/graphql';

export const deletePageUpdate = (cache: DataProxy, data?: Maybe<DeletePageMutation>) => {
  const { pages } = cache.readQuery<PagesQuery>({ query: pagesQuery })!;

  const nextState = produce(pages, draft => {
    draft.splice(
      draft.findIndex(i => i.id === data?.deletePage.id),
      1
    );
  });

  cache.writeQuery({
    query: pagesQuery,
    data: { pages: nextState },
  });
};
